import folderIdFactory from 'owa-service/lib/factory/folderId';
import getCalendarViewOperation from 'owa-service/lib/operation/getCalendarViewOperation';
import getCalendarViewRequest from 'owa-service/lib/factory/getCalendarViewRequest';
import GetCalendarViewResponse from 'owa-service/lib/contract/GetCalendarViewResponse';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import { DisplayDate, getEwsRequestString } from 'owa-datetime';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { CalendarId } from 'owa-calendar-cache';
import { getDefaultRequestOptions } from 'owa-headers';

const HEADER_EXPLICIT_LOGON_USER: string = 'X-OWA-ExplicitLogonUser';
const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';

/**
 * Makes the GetCalendarView call to the server to get calendar items for default calendar
 * @param {Date} rangeStart start of request range
 * @param {Date} rangeEnd end of request range
 * @param {string} folderId folder id of requested calendar
 * @param {string} email smtp addres of request mailbox
 * @returns promise of GetCalendarViewResponse type
 */
export default function getCalendarViewService(
    rangeStart: DisplayDate,
    rangeEnd: DisplayDate,
    folderId: string = folderNameToId('calendar'),
    calendarId?: CalendarId,
    email?: string,
    includeDeclinedMeetings?: boolean
): Promise<GetCalendarViewResponse> {
    let options = null;
    if (email) {
        options = {
            headers: <any>{
                [HEADER_EXPLICIT_LOGON_USER]: email,
                [HEADER_ANCHOR_MAILBOX]: email,
            },
        };
    } else if (calendarId) {
        options = getDefaultRequestOptions(calendarId.mailboxInfo);
    }

    return getCalendarViewOperation(
        {
            Header: getJsonRequestHeader(),
            Body: getCalendarViewRequest({
                CalendarId: targetFolderId({
                    BaseFolderId: folderIdFactory({ Id: folderId }),
                }),
                RangeStart: getEwsRequestString(rangeStart),
                RangeEnd: getEwsRequestString(rangeEnd),
                IncludeDeclinedMeetings: includeDeclinedMeetings,
            }),
        },
        options
    ).then(response => {
        return response.Body;
    });
}
